export default {
      id: "close-usage",
      viewBox: "0 0 16 16",
      url: "../../assets/" + "sprite.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }